import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';

function formatCurrency(value) {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
  return `$${value}`;
}

export default function MiniPipelineChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="mini-chart-empty">No pipeline data</div>;
  }

  const chartData = data
    .filter(d => !d.is_won && !d.is_lost)
    .map(d => ({ name: d.stage, value: d.total_amount, count: d.count }));

  return (
    <div className="mini-chart-container">
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={chartData} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <XAxis dataKey="name" tick={{ fontSize: 10, fill: 'var(--color-text-secondary)' }} />
          <YAxis tickFormatter={formatCurrency} tick={{ fontSize: 10, fill: 'var(--color-text-secondary)' }} width={50} />
          <Tooltip formatter={(v) => formatCurrency(v)} />
          <Bar dataKey="value" fill="#3b82f6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <Link to="/reports?type=sales_pipeline" className="mini-chart-link">View Full Report</Link>
    </div>
  );
}
